var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg040305(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_247_370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0885 38.8545C15.1305 38.3451 14.4259 37.489 14.0978 36.445L8.53321 21.7619C7.68023 18.816 8.08911 15.6637 9.64388 13.0429C10.399 11.7673 11.3858 10.677 12.573 9.80198C13.8099 8.89126 15.1999 8.25603 16.7117 7.92625C19.0834 7.40925 21.4787 7.74337 23.6463 8.89588C26.1072 10.2044 27.1715 13.6196 28.0717 16.3034C30.8 15.549 34.5678 14.703 37.0228 16.0083C39.1903 17.1608 40.8067 18.9598 41.7043 21.2151C42.2763 22.6528 42.5329 24.1636 42.4636 25.6951C42.402 27.1687 42.0439 28.5933 41.4086 29.9326C40.1085 32.681 37.7205 34.7888 34.8537 35.7025L34.7892 35.7226L34.6576 35.7535L19.1353 39.1623C18.1415 39.4569 17.0378 39.3514 16.0857 38.8452L16.0885 38.8545Z",
    fill: "#FF9797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9178 41.0562C14.9888 41.0939 15.0611 41.128 15.1343 41.1583C16.5789 41.8587 18.2263 42.0058 19.7471 41.581L35.1924 38.189L35.228 38.181L35.3597 38.15C35.4174 38.1365 35.4746 38.1208 35.5312 38.1032L35.5956 38.0831L35.6109 38.0783C39.148 36.951 42.0715 34.3619 43.6622 31C44.4367 29.3668 44.8786 27.6166 44.9549 25.803C45.0396 23.9155 44.7218 22.0541 44.0213 20.2934L44.0212 20.293C42.9028 17.4829 40.8769 15.2334 38.1935 13.8066C36.337 12.8195 34.2052 12.7403 32.4269 12.8998C31.4899 12.9839 30.5585 13.1438 29.6849 13.3319C29.3953 12.5481 29.0611 11.7306 28.6681 10.9559C27.8836 9.40921 26.7059 7.69857 24.817 6.69417C22.1335 5.26736 19.1357 4.84569 16.1806 5.48987L16.1802 5.48995C14.321 5.89555 12.6092 6.67878 11.0946 7.79395L11.0936 7.79468C9.63737 8.86794 8.42413 10.2085 7.49866 11.7717C5.59381 14.9832 5.09301 18.8464 6.13798 22.4555C6.15657 22.5197 6.17774 22.5831 6.20143 22.6456L11.7434 37.2689C12.2747 38.8924 13.3953 40.2466 14.9178 41.0562Z",
    stroke: "white",
    strokeWidth: 4.9872,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_247_370",
    x: 0.615286,
    y: 0.832436,
    width: 49.3402,
    height: 46.5967,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.6234
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2468
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_247_370"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_247_370",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg040305);
export default __webpack_public_path__ + "static/media/img_04_03_05.cfdf92b2bdae3387f003811760b32ddf.svg";
export { ForwardRef as ReactComponent };